module.exports = __webpack_public_path__ + "static/media/HappyFace.56926920.svg";